const init = (instantiate: () => void): void => {
  document.addEventListener('DOMContentLoaded', (): void => {
    instantiate();
  });
};
const onShopifySectionLoad = (run: (event: Event) => void): void => {
  const shopifyEvents = [
    'shopify:section:load'
  ];
  shopifyEvents.forEach((eventName): void => {
    document.addEventListener(eventName, (event): void => run(event));
  });
};


export {
  init,
  onShopifySectionLoad
};
